import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const StoreInfoList = styled.ul`
  list-style-position: inside;
`;

type StoreInfoProps = {
  showPriceListExpandedPriceRowExperiment: boolean;
};

export const StoreInfoText = styled.li<StoreInfoProps>(
  props => css`
    &:last-of-type {
      margin-bottom: ${layout.spacing.small};
    }

    color: ${props.theme.lines.secondary};

    ${props.showPriceListExpandedPriceRowExperiment &&
      css`
        color: ${props.theme.text.secondary};
      `}
  `
);

export const StoreInfoTextInner = styled.span<StoreInfoProps>(
  props => css`
    ${!props.showPriceListExpandedPriceRowExperiment &&
      css`
        color: ${props.theme.text.primary};
      `}
  `
);
